<div class="review-modal" *transloco="let t; prefix: 'assetShared.excelReview'">

  <div class="review-modal__header">
    <div>
      <h5 class="review-modal__title">{{ title }}</h5>
      <p class="review-modal__subtitle">{{ subtitle }}</p>
    </div>
    <button class="review-modal__close" (click)="closeRequested.emit()">
      <i class="ph ph-x"></i>
    </button>
  </div>

  @if(isLoading) {
    <div class="review-modal__loading">
      <span class="spinner-border"></span>
    </div>
  } @else {
    <div class="review-modal__content">

      <div class="review-modal__toolbar">
        <div class="tabs">
          <button type="button" class="tab" [class.tab--active]="activeTab === 'all'" (click)="setTab('all')">
            <span>{{ t('all') }}</span>
            <span class="tab__badge" [class.tab__badge--inverted]="activeTab === 'all'">{{ items.length }}</span>
          </button>
          <button type="button" class="tab" [class.tab--active]="activeTab === 'error'" (click)="setTab('error')">
            <span>{{ t('error') }}</span>
            <span class="tab__badge" [class.tab__badge--inverted]="activeTab === 'error'">{{ errorCount }}</span>
          </button>
        </div>

        @if(showAccountFilter) {
          <div class="toolbar-account">
            <app-account-filter [placeholder]="accountFilterPlaceholder" [filter]="accountFilter" (filterChanged)="onAccountFilterChange($event)"></app-account-filter>
          </div>
        } @else {
          <div class="toolbar-spacer"></div>
        }

        <app-search [placeholder]="searchPlaceholder" [customWidth]="searchWidth" (searchTermUpdated)="onSearch($event)"></app-search>
      </div>

      @if(serverErrors.length > 0) {
        <div class="callout callout--warning review-modal__server-errors">
          <span class="callout__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12.8842 2.53152C12.5382 1.87752 11.4622 1.87752 11.1162 2.53152L2.11625 19.5315C1.95225 19.8415 1.96225 20.2155 2.14325 20.5145C2.32425 20.8155 2.64925 20.9995 3.00025 20.9995H21.0002C21.3512 20.9995 21.6762 20.8155 21.8562 20.5155C22.0382 20.2155 22.0472 19.8415 21.8832 19.5325L12.8842 2.53152ZM13.0002 17.9995H11.0002V15.9995H13.0002V17.9995ZM11.0002 13.9995V8.99952H13.0002L13.0012 13.9995H11.0002Z" fill="#F7F5F5"/>
            </svg>
          </span>
          <div>
            <strong>{{ t('importRejected') }}</strong>
            @for(error of serverErrors; track error) {
              <div>{{ error }}</div>
            }
          </div>
        </div>
      }

      <div class="review-modal__body">

        <div class="table-scroll">
          <table class="review-table">
            <thead>
              <tr>
                <th class="col-icon"></th>
                <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
                <th>{{ t('status') }}</th>
                <th class="col-delete"></th>
              </tr>
            </thead>
            <tbody>
              @for(item of filteredItems; track item) {
                <tr [class.selected]="item === selected" [class.has-error]="item.errors.length > 0" (click)="select(item)">
                  <td class="col-icon">
                    @if(item.errors.length > 0) {
                      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                        <path d="M7.47062 1.25C4.04063 1.25 1.25 4.05375 1.25 7.5C1.25 10.9462 4.05375 13.75 7.5 13.75C10.9462 13.75 13.75 10.9462 13.75 7.5C13.75 4.05375 10.9331 1.25 7.47062 1.25ZM8.125 10.625H6.875V9.375H8.125V10.625ZM8.125 8.125H6.875V4.375H8.125V8.125Z" fill="#FF7F00"/>
                      </svg>
                    }
                  </td>
                  <ng-container *ngTemplateOutlet="rowTemplate; context: { $implicit: item }"></ng-container>
                  <td>
                    @if(item.errors.length > 0) {
                      <span class="status non-compliant">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                          <path d="M6.63533 0C2.97667 0 0 2.99067 0 6.66667C0 10.3427 2.99067 13.3333 6.66667 13.3333C10.3427 13.3333 13.3333 10.3427 13.3333 6.66667C13.3333 2.99067 10.3287 0 6.63533 0ZM7.33333 10H6V8.66667H7.33333V10ZM7.33333 7.33333H6V3.33333H7.33333V7.33333Z" fill="#FF7F00"/>
                        </svg>
                        {{ t('error') }}
                      </span>
                    } @else {
                      <span class="status compliant">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7.9987 1.33594C4.3227 1.33594 1.33203 4.3266 1.33203 8.0026C1.33203 11.6786 4.3227 14.6693 7.9987 14.6693C11.6747 14.6693 14.6654 11.6786 14.6654 8.0026C14.6654 4.3266 11.6747 1.33594 7.9987 1.33594ZM6.66603 10.9446L4.1907 8.4746L5.13203 7.5306L6.6647 9.0606L10.194 5.53127L11.1367 6.47394L6.66603 10.9446Z" fill="#50AD41"/>
                        </svg>
                        {{ t('valid') }}
                      </span>
                    }
                  </td>
                  <td class="col-delete">
                    <button type="button" class="delete-btn" (click)="removeItem(item); $event.stopPropagation()">
                      <i class="ph ph-trash"></i>
                    </button>
                  </td>
                </tr>
              } @empty {
                <tr>
                  <td class="empty-cell" [attr.colspan]="columnCount + fixedColumnCount">
                    <div class="empty-state">
                      <img src="assets/icons/exclamation_circle.svg" [attr.alt]="t('noDataAvailable')">
                      <span>{{ emptyText || t('emptyText') }}</span>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <div class="detail-panel">
          @if(selected) {
            <div class="detail-panel__header">
              <h6 class="detail-panel__title">{{ selected.errors.length > 0 ? t('error') : t('details') }}</h6>
            </div>

            <div class="detail-panel__content">
              @if(selected.errors.length > 0) {
                <div class="callout callout--warning">
                  <span class="callout__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M12.8842 2.53152C12.5382 1.87752 11.4622 1.87752 11.1162 2.53152L2.11625 19.5315C1.95225 19.8415 1.96225 20.2155 2.14325 20.5145C2.32425 20.8155 2.64925 20.9995 3.00025 20.9995H21.0002C21.3512 20.9995 21.6762 20.8155 21.8562 20.5155C22.0382 20.2155 22.0472 19.8415 21.8832 19.5325L12.8842 2.53152ZM13.0002 17.9995H11.0002V15.9995H13.0002V17.9995ZM11.0002 13.9995V8.99952H13.0002L13.0012 13.9995H11.0002Z" fill="#F7F5F5"/>
                    </svg>
                  </span>
                  <div>
                    <strong>{{ warningTitle(selected) }}</strong>
                    @for(error of selected.errors; track error.message) {
                      <div>{{ error.message }}</div>
                    }
                  </div>
                </div>

                @if(suggestions(selected).length > 0) {
                  <div class="suggestions">
                    @for(suggestion of suggestions(selected); track suggestion.field + suggestion.value) {
                      <div class="suggestions__row">
                        <span class="suggestions__label">{{ suggestion.label }}</span>
                        <span class="suggestions__value">{{ suggestion.value }}</span>
                      </div>
                    }
                    <button type="button" class="apply-suggestion-btn" (click)="onApplySuggestions()">
                      {{ suggestions(selected).length > 1 ? t('applySuggestions') : t('applySuggestion') }}
                    </button>
                  </div>
                }
              }

              <ng-container *ngTemplateOutlet="detailTemplate; context: { $implicit: selected }"></ng-container>
            </div>
          } @else {
            <div class="detail-panel__empty">{{ detailEmptyText || t('detailEmptyText') }}</div>
          }
        </div>

      </div>

    </div>

    <div class="review-modal__footer">
      <button class="cancel-btn" (click)="closeRequested.emit()">{{ 'common.cancel' | transloco }}</button>
      <button class="import-btn" [disabled]="!canImport" (click)="importRequested.emit()">
        {{ isImporting ? t('importing') : (importLabel || t('import')) }}
      </button>
    </div>
  }

</div>
